exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".list-skill .odd{\n    background-color:#ffffff ;\n}\n.list-skill .even{\n    background-color:#e6e6e6;\n}\n\n.list-skill-filter {\n  margin-bottom: 20px;\n}\n\n::ng-deep .list-skill .dropdown {\n  width: 100%;\n}\n\n::ng-deep .list-skill .dropdown .btn {\n  background-color: #fff;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  text-transform: capitalize;\n}\n\n::ng-deep .list-skill .dropdown .btn .caret {\n  position: absolute;\n  right: 0;\n  top: 16px;\n  margin-right: 6px;\n}\n::ng-deep .list-skill .open>.dropdown-toggle.btn-default:hover {\n  background-color: #fff;\n}\n\n::ng-deep .list-skill .open>.dropdown-menu {\n  padding: 5px;\n  font-size: 15px;\n}\n\n::ng-deep .list-skill .open>.dropdown-menu span[role=\"menuitem\"] {\n  color: black;\n  outline: none;\n  text-transform: capitalize;\n}\n\n::ng-deep .list-skill .open>.dropdown-menu .input-group {\n  display: -ms-inline-flexbox;\n  display: inline-flex;\n}\n\n::ng-deep .list-skill .open>.dropdown-menu .input-group .input-group-append .btn {\n  padding: 6px;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/agira/Desktop/BU-Intra/agira-intranet-ui/src/app/skill-matrix/list-skill/list-skill.component.css
// module id = ../../../../../src/app/skill-matrix/list-skill/list-skill.component.css
// module chunks = main